import React, { useContext, useState } from "react";
import logo from "../assets/images/paysmart.png";
import { userContext } from "../context/UserContext";
import { ThreeDots } from "react-loader-spinner";
import axios from "axios";
import QRCode from "qrcode.react";
import { toast, ToastContainer } from "react-toastify";
import { useHistory } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";

import { Layout, Button, Row, Col, Typography, Form, Input } from "antd";

const Signin = () => {
  const { updateUser, generateTfa, enableTfa } = useContext(userContext);

  const [loading, setLoading] = useState(false);
  const [step, setStep] = useState("login");
  const [credentials, setCredentials] = useState(null);
  const [tfaData, setTfaData] = useState(null);
  const history = useHistory();

  const onFinish = async (values) => {
    setLoading(true);
    const result = await updateUser(values);

    if (result.success) {
      if (result.tfaEnabled) {
        setLoading(false);
        history.push("/dashboard");
        return;
      }

      try {
        const data = await generateTfa(values.password);
        setCredentials(values);
        setTfaData(data);
        setStep("setup");
      } catch (err) {
        toast.error("Failed to generate authenticator secret", {
          position: toast.POSITION.TOP_LEFT,
        });
      }
      setLoading(false);
      return;
    }

    setLoading(false);

    if (result.otpRequired) {
      setCredentials(values);
      setStep("otp");
      return;
    }

    toast.error(result.error || "Invalid email or password", {
      position: toast.POSITION.TOP_LEFT,
    });
  };

  const onSetupFinish = async (values) => {
    setLoading(true);
    try {
      await enableTfa(tfaData.secret, values.otp);
      setLoading(false);
      history.push("/dashboard");
    } catch (err) {
      setLoading(false);
      toast.error("Invalid code — please try again", {
        position: toast.POSITION.TOP_LEFT,
      });
    }
  };

  const onOtpFinish = async (values) => {
    setLoading(true);
    const result = await updateUser({ ...credentials, otp: values.otp });
    setLoading(false);
    if (result.success) {
      history.push("/dashboard");
    } else {
      toast.error("Invalid code — please try again", {
        position: toast.POSITION.TOP_LEFT,
      });
    }
  };

  const onFinishFailed = () => {};

  const backToLogin = () => {
    setStep("login");
    setCredentials(null);
    setTfaData(null);
  };

  const { Title } = Typography;
  const { Header, Content } = Layout;

  return (
    <>
      <Layout
        className="layout-default layout-signin"
        style={{ backgroundColor: "white" }}
      >
        <Content className="signin">
          <Row gutter={[24, 0]} justify="center" style={{ marginTop: "200px" }}>
            <Col
              xs={{ span: 24, offset: 0 }}
              lg={{ span: 6, offset: 2 }}
              md={{ span: 12 }}
            >
              <Title
                level={4}
                style={{ textAlign: "center", marginBottom: "34px" }}
              >
                Paysmart Payment Portal
              </Title>

              {step === "login" && (
                <Form
                  onFinish={onFinish}
                  onFinishFailed={onFinishFailed}
                  layout="vertical"
                  className="row-col"
                >
                  <Form.Item
                    className="username"
                    label="Email"
                    name="email"
                    rules={[
                      {
                        required: true,
                        message: "Please input your email!",
                      },
                    ]}
                  >
                    <Input type="email" placeholder="Email" />
                  </Form.Item>

                  <Form.Item
                    className="username"
                    label="Password"
                    name="password"
                    rules={[
                      {
                        required: true,
                        message: "Please input your password!",
                      },
                    ]}
                  >
                    <Input type="password" placeholder="Password" />
                  </Form.Item>

                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <ThreeDots
                      height="40"
                      width="40"
                      radius="4"
                      color="#1890FF"
                      ariaLabel="three-dots-loading"
                      wrapperStyle={{}}
                      wrapperClassName=""
                      visible={loading}
                    />
                  </div>

                  <Form.Item>
                    <Button
                      type="primary"
                      htmlType="submit"
                      style={{ width: "100%" }}
                      disabled={loading}
                    >
                      LOG IN
                    </Button>
                  </Form.Item>
                </Form>
              )}

              {step === "setup" && tfaData && (
                <div>
                  <Title
                    level={3}
                    style={{
                      textAlign: "center",
                      marginBottom: "4px",
                    }}
                  >
                    Set up two-factor authentication
                  </Title>
                  <Typography.Paragraph
                    type="secondary"
                    style={{
                      textAlign: "center",
                      marginBottom: "24px",
                    }}
                  >
                    Protect your account with Google Authenticator.
                  </Typography.Paragraph>

                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      marginBottom: "20px",
                    }}
                  >
                    <div
                      style={{
                        padding: "16px",
                        background: "#fff",
                        border: "1px solid #f0f0f0",
                        borderRadius: "8px",
                        boxShadow: "0 2px 8px rgba(0, 0, 0, 0.04)",
                      }}
                    >
                      <QRCode value={tfaData.otpauth_url} size={180} />
                    </div>
                  </div>

                  <ol
                    style={{
                      paddingLeft: "20px",
                      margin: "0 0 20px 0",
                      color: "rgba(0, 0, 0, 0.65)",
                      lineHeight: "1.8",
                    }}
                  >
                    <li>Open the Google Authenticator app</li>
                    <li>
                      Tap <strong>+</strong> and select{" "}
                      <strong>Scan a QR code</strong>
                    </li>
                    <li>Enter the 6-digit code below to verify</li>
                  </ol>

                  <Typography.Paragraph
                    type="secondary"
                    style={{
                      fontSize: "12px",
                      textAlign: "center",
                      marginBottom: "16px",
                    }}
                  >
                    Can't scan? Enter this key manually:
                    <br />
                    <Typography.Text
                      code
                      copyable
                      style={{ fontSize: "12px" }}
                    >
                      {tfaData.secret}
                    </Typography.Text>
                  </Typography.Paragraph>

                  <Form
                    onFinish={onSetupFinish}
                    onFinishFailed={onFinishFailed}
                    layout="vertical"
                    className="row-col"
                  >
                    <Form.Item
                      className="otp"
                      label="Verification code"
                      name="otp"
                      rules={[
                        {
                          required: true,
                          message: "Please enter the 6-digit code",
                        },
                      ]}
                    >
                      <Input
                        type="number"
                        placeholder="123456"
                        maxLength={6}
                        style={{
                          letterSpacing: "4px",
                          textAlign: "center",
                          fontSize: "18px",
                        }}
                      />
                    </Form.Item>

                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <ThreeDots
                        height="40"
                        width="40"
                        radius="4"
                        color="#1890FF"
                        ariaLabel="three-dots-loading"
                        visible={loading}
                      />
                    </div>

                    <Form.Item>
                      <Button
                        type="primary"
                        htmlType="submit"
                        size="large"
                        style={{ width: "100%" }}
                        disabled={loading}
                      >
                        Verify & Continue
                      </Button>
                    </Form.Item>
                    <Typography.Text
                      type="secondary"
                      onClick={backToLogin}
                      style={{
                        display: "block",
                        textAlign: "center",
                        cursor: "pointer",
                        color: "#1890ff",
                      }}
                    >
                      Back to Login
                    </Typography.Text>
                  </Form>
                </div>
              )}

              {step === "otp" && (
                <Form
                  onFinish={onOtpFinish}
                  onFinishFailed={onFinishFailed}
                  layout="vertical"
                  className="row-col"
                >
                  <Form.Item
                    className="otp"
                    label="Authenticator code"
                    name="otp"
                    rules={[
                      {
                        required: true,
                        message: "Please enter the 6-digit code",
                      },
                    ]}
                  >
                    <Input type="number" placeholder="6-digit code" />
                  </Form.Item>

                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <ThreeDots
                      height="40"
                      width="40"
                      radius="4"
                      color="#1890FF"
                      ariaLabel="three-dots-loading"
                      visible={loading}
                    />
                  </div>

                  <Form.Item>
                    <p
                      style={{
                        textAlign: "center",
                      }}
                    >
                      Open Google Authenticator and enter the current code.
                    </p>
                    <Button
                      type="primary"
                      htmlType="submit"
                      style={{ width: "100%" }}
                      disabled={loading}
                    >
                      PROCEED
                    </Button>
                  </Form.Item>
                  <Typography.Text
                    type="secondary"
                    onClick={backToLogin}
                    style={{
                      display: "block",
                      textAlign: "center",
                      cursor: "pointer",
                      textDecoration: "underline",
                      color: "#1890ff",
                    }}
                  >
                    Back to Login
                  </Typography.Text>
                </Form>
              )}
            </Col>
          </Row>
          <ToastContainer />
        </Content>
      </Layout>
    </>
  );
};

export default Signin;
